import Vue from 'vue'
import App from './App.vue'
import axios from 'axios';
import router from './router'
import store from './store';
import moment from 'moment'//时间戳转化插件  npm install --save moment
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.config.productionTip = false

import './assets/font-awesome.min.css'
import './assets/style.css'

Vue.prototype.$moment = moment

localStorage.setItem("w", "eAArXoqV");

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
